module.exports = __webpack_public_path__ + "img/adminServiceInfo2.8f5c99bb.png";